import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// Components
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Settings from './Settings';
import Actions from './Actions';
import Recent from './Recent';

interface SidebarProps {
    isMobile: boolean;
    isOpen?: boolean; // Only relevant for mobile Drawer state
    onClose?: () => void; // Only relevant for mobile Drawer state
}

const Sidebar: React.FC<SidebarProps> = ({ isMobile, isOpen, onClose }) => {

    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const colors = useAppSelector(state => state.theme.colors);

    const sidebarContent = (
        <>
            {/* The close button was removed as per user request. Tapping outside the drawer closes it. */}
            
            <Box sx={{ flexGrow: 1, width: '100%', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                <Recent isMobile={isMobile} onClose={onClose} />
            </Box>

            <Box sx={{ width: '100%', flexShrink: 0 }}>
                <Settings />
            </Box>
        </>
    );

    // Render directly with positioning for desktop
    if (!isMobile) {
        return (
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '19.5%',
                height: '98%',
                bottom: '1%',
                position: 'absolute',
                left: '0.5%',
                borderRadius: 2,
                backgroundColor: colors?.container,
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
                overflowY: 'hidden',
            }}>
                {sidebarContent}
            </Box>
        );
    }

    // Render content without outer positioning for mobile (Drawer handles positioning)
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%', // Fill the drawer
            height: '100%', // Fill the drawer
            backgroundColor: colors?.container, // Ensure background color
            overflowY: 'auto', // Allow scrolling within the drawer if content overflows
        }}>
            {sidebarContent}
        </Box>
    );

};

export default Sidebar;